// import { getMenu } from "../api/setting/menu";
import { getUserInfo } from "../api/login/index";
export default {
    state: {
        //菜单数据
        menuList: [],
        //用户信息
        userInfo: {},
        //按钮权限信息
        userPermissions: [],
        //角色信息
        userRoles: [],
    },

    mutations: {
        //设置muneList
        setMenulist(state, list) {
            state.menuList = list;
        },
        //设置用户信息
        setUserInfo(state, obj) {
            state.userInfo = obj;
        },
        //设置按钮权限信息
        setUserPermissions(state, list) {
            state.userPermissions = list;
        },
        //设置角色信息
        setUserRoles(state, list) {
            state.userRoles = list;
        },

        //生成动态路由
        dynamicRouter(state, router) {
            //获取原来的路由

            let oldRouter = [];
            let menuList = state.menuList;

            //递归将路由数据写入到路由表中
            addRouter(menuList);
            for (let x of oldRouter) {
                router.addRoute("home", x);
            }

            //递归方法
            function addRouter(menuList) {
                if (Array.isArray(menuList) && menuList.length > 0) {
                    menuList.forEach((item) => {
                        if (item.children.length == 0) {
                            item.component = (resolve) =>
                                require([`@/views${item.path}.vue`], resolve);
                            item.meta = { title: item.label };
                            delete item.name;
                            oldRouter.push(item);
                        }
                        addRouter(item.children);
                    });
                }
            }
        },

        //清空vuex里面所有内容
        clearVuex(state) {
            state.userInfo = null;
            state.menuList = [];
            state.userPermissions = [];
            state.userRoles = [];
        },
    },
    actions: {
        async getAllInfo({ commit }) {
            //获取用户信息保存到vuex
            let { data: userInfo } = await getUserInfo();
            //把获取到的用户信息存放到vuex中
            commit("setUserInfo", userInfo.data.sysUser);

            //把获取到的用户按钮权限存储到vuex中
            commit("setUserPermissions", userInfo.data.permissions);

            //把获取到的用户角色存储到vuex中
            commit("setUserRoles", userInfo.data.roles);
        },

        //退出时执行清空所有vuex里面的内容
        clearAllVuex({ commit }) {
            commit("clearVuex");
        },
    },
};
